module.exports = __webpack_public_path__ + "img/60.8dce7765.png";